import React, {useRef} from "react";
import RenderIf from "@/components/Global/RenderIf/RenderIf";
import FileDropzone from "@/components/Global/FileDropzone/FileDropzone";
import Button from "@/components/Global/Button/Button";
import AccentMarks from "@/components/Global/AccentMarks/AccentMarks";

import styles from "./CustomerPicture.module.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPenToSquare} from "@fortawesome/free-regular-svg-icons/faPenToSquare";

export default function CustomerPictureContainer({
  showMarks = false,
  allowEdit = false,
  showShadow = true,
  className = "",
  handlePictureUpload,
  children,
}) {
  const handlePictureInput = e => {
    const image = e.target.files[0];
    handlePictureUpload(image);
  };

  const imageUploadRef = useRef(null);

  const handleClick = () => {
    imageUploadRef.current.click();
  };

  return (
    <>
      <RenderIf isTrue={allowEdit}>
        <div className={`${styles.profileMaxWidth} position-relative`}>
          <RenderIf isTrue={showMarks}>
            <AccentMarks className={styles.accentMarks} />
          </RenderIf>

          <FileDropzone
            className={`${styles.uploadImageDefault} ${className} ${showShadow ? styles.shadow : ""}`}
            onDrop={handlePictureUpload}
            allowedType="image">
            {children}
          </FileDropzone>

          <RenderIf isTrue={allowEdit}>
            <Button
              onClick={handleClick}
              variant="default"
              className={`${styles.uploadButton} cursor-pointer`}
              aria-label="Upload image">
              <FontAwesomeIcon icon={faPenToSquare} className="fa-fw" />
              <input ref={imageUploadRef} type="file" accept="image/*" hidden onChange={handlePictureInput} />
            </Button>
          </RenderIf>
        </div>
      </RenderIf>

      <RenderIf isTrue={!allowEdit}>
        <div className={`${styles.uploadImageDefault} ${className} ${showShadow ? styles.shadow : ""}`}>{children}</div>
      </RenderIf>
    </>
  );
}
